import { render, staticRenderFns } from "./StudentDateReport.vue?vue&type=template&id=0af95348&scoped=true"
import script from "./StudentDateReport.vue?vue&type=script&lang=js"
export * from "./StudentDateReport.vue?vue&type=script&lang=js"
import style0 from "./StudentDateReport.vue?vue&type=style&index=0&id=0af95348&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af95348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af95348')) {
      api.createRecord('0af95348', component.options)
    } else {
      api.reload('0af95348', component.options)
    }
    module.hot.accept("./StudentDateReport.vue?vue&type=template&id=0af95348&scoped=true", function () {
      api.rerender('0af95348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/StudentDateReport.vue"
export default component.exports